export default "__VITE_ASSET__CNiDLzLi__"